<template lang="pug">
  div
    model-data-table( 
        no-data-text="Sin notas de débito"
        no-search 
        no-remove
        @detail="submitShow"
        ref="table" 
        v-bind="tableProps" 
    )
    nd-detail-dialog(
          :debitNoteId="debitNoteId"
          :debitNoteModel="debitNoteMdl"
          read-only
          ref="debitNoteDialog"
        )
</template>

<script>
    //
    import { mapActions } from "vuex"
    import { ModelDataTable } from "@/components/reusable_components/next"
    import SaleDebitNoteModel from "@/models/Sale/SlSaleDebitNote"
    //
    import SaleDebitNoteHeaders from "./headers/debitNote"
    import SaleDebitNoteFilters from "./filters/debitNoteFilters"
    //
    import DetailDebitNoteDialog from '@/components/reusable_components/DocumentDetail/debitNote/DebitNoteDetail'
    import DebitNoteModel from '@/models/Sale/SlSaleDebitNote'
    //
    export default {
        beforeMount () {            
            this.setTitleTopBar( "Notas de débito" )
        },
        components: {
            ModelDataTable,
            'nd-detail-dialog' :DetailDebitNoteDialog,
        },
        data: function() {
        return {
            customerId: null,
            debitNoteId:null,
            debitNoteMdl:DebitNoteModel

        }
        },
        computed: {

            /**
             * 
             */
            tableProps() {
                return {
                    filters: SaleDebitNoteFilters,
                    headers: SaleDebitNoteHeaders,
                    service: SaleDebitNoteModel,
                    paramFilter: {
                      sl_customer_id: this.customerId,
                    },
                }
            },
        },
        methods: {            
            /* 
             */
            setCustomerId() {
              this.customerId = this.$route.params.id
            },
            /*
             */
            submitShow(event) {
              this.debitNoteId = event.item.id
              this.$refs.debitNoteDialog.open = true
            },
            /**
             * 
             */
            ...mapActions("MenuesModule", [
                "setItemsTopBar",
                "setTitleTopBar",
            ]),

            /**
             * 
             */
            submitCreate () {
                this.$router.push({ name: "sale-debit-note-create" })
            },

            /**
             * 
             */
            // submitDetail ( event ) {
            //     this.$router.push({ name: "sale-debit-note-update", params: { id: event.item.id } })
            // },
        },
        mounted () {
            /*this.setItemsTopBar([
                {
                    action: this.submitCreate,
                    icon: "add_circle",
                    text: "crear nota de debito",
                    tooltip: "Crear nueva nota de debto",
                }
            ])*/
        },
        beforeMount(){
          this.setCustomerId()
        }
    }
</script>